module.exports = __webpack_public_path__ + "img/Jacksonville-uni-logo.16252961.png";